const SET_HTTP_REQUEST_LIST = 'SET_HTTP_REQUEST_LIST'

const state = {
  httpRequestList: [],
}

const mutations = {
  [SET_HTTP_REQUEST_LIST]: (state, payload) => {
    if (payload == 0) {
      //强行中断时才向下执行
      state.httpRequestList.forEach(item => {
        if(item)
          item('interrupt') //给个标志，中断请求
      })
      state.httpRequestList = []
    } else {
      state.httpRequestList.push(payload)
    }
  },
}

const actions = {
  removeHttpRequestList({ commit }) {
    commit(SET_HTTP_REQUEST_LIST, 0)
  },
  addHttpRequestList({ commit },val) {
    commit(SET_HTTP_REQUEST_LIST, val)
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
